module.exports = __webpack_public_path__ + "img/prime_file-excel.a591beee.svg";